import { useState } from "react";
import type { FormEvent } from "react";
import { submitReaddyForm } from "@/utils/formSubmit";

const SUBMIT_ADDR = "https://readdy.ai/api/form/dahbjnroh653ivfvnqj0";

const benefits = [
  { icon: "ri-mail-check-line", text: "每周一封，精选三篇值得读的长文" },
  { icon: "ri-calendar-check-line", text: "附下周值得关注的娱乐日程提醒" },
  { icon: "ri-shield-check-line", text: "不推送广告，随时可以退订" },
];

export default function SubscribeSection() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [feedback, setFeedback] = useState("");

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    setStatus("loading");
    setFeedback("");
    const result = await submitReaddyForm(SUBMIT_ADDR, form, "订阅成功，欢迎加入瓜网读者群。");
    if (result.ok) {
      setStatus("success");
      setFeedback(result.message);
      form.reset();
    } else {
      setStatus("error");
      setFeedback(result.message);
    }
  };

  return (
    <section id="subscribe" className="scroll-mt-28 bg-background-50">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 rounded-lg bg-secondary-900 p-6 md:p-10 lg:grid-cols-2 lg:items-center">
          <div>
            <p className="mb-2 flex items-center gap-2 text-xs font-medium uppercase tracking-[0.22em] text-secondary-200">
              <i className="ri-send-plane-line" aria-hidden="true"></i>
              Newsletter
            </p>
            <h2 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
              订阅瓜网周报
            </h2>
            <p className="mt-3 max-w-lg text-sm leading-relaxed text-background-200">
              每周日晚发出，帮你把这一周真正值得看的娱乐内容挑出来，省下刷热搜的时间。
            </p>
            <ul className="mt-6 space-y-3">
              {benefits.map((item) => (
                <li key={item.text} className="flex items-center gap-3 text-sm text-background-100">
                  <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-secondary-700">
                    <i className={`${item.icon} text-secondary-100`} aria-hidden="true"></i>
                  </span>
                  {item.text}
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-lg bg-background-50 p-5 md:p-6">
            <form onSubmit={handleSubmit} data-readdy-form id="newsletter-form" noValidate={false}>
              <label htmlFor="newsletter-email" className="block text-sm font-medium text-foreground-800">
                邮箱地址
              </label>
              <div className="mt-2 flex flex-col gap-3 sm:flex-row">
                <input
                  id="newsletter-email"
                  type="email"
                  name="email"
                  required
                  placeholder="you@example.com"
                  autoComplete="email"
                  className="w-full rounded-md border border-background-300 bg-background-50 px-3 py-2.5 text-sm text-foreground-900 outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
                />
                <button
                  type="submit"
                  disabled={status === "loading"}
                  className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 disabled:opacity-60"
                >
                  {status === "loading" ? "提交中…" : "免费订阅"}
                </button>
              </div>

              <input
                type="text"
                name="website_alt"
                className="form-guard-field"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />

              <p className="mt-2 text-xs text-foreground-500">
                我们只会用它发送周报，不会用于其他用途。
              </p>

              {status === "success" && (
                <p role="status" className="mt-3 flex items-center gap-2 rounded-md bg-secondary-100 px-3 py-2 text-sm text-secondary-900">
                  <i className="ri-checkbox-circle-line" aria-hidden="true"></i>
                  {feedback}
                </p>
              )}
              {status === "error" && (
                <p role="alert" className="mt-3 flex items-center gap-2 rounded-md bg-accent-100 px-3 py-2 text-sm text-accent-900">
                  <i className="ri-error-warning-line" aria-hidden="true"></i>
                  {feedback}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}